import React from 'react';
import { motion } from 'framer-motion';
import { Icon } from '../ui/Icon';
const weeks = [{
  week: 'Semana 1',
  title: 'Oferta + Copywriting',
  value: '$497',
  icon: 'book',
  description: 'Transforma tu idea en una oferta irresistible y escribe texto que VENDE.'
}, {
  week: 'Semana 2',
  title: 'Página + VSL',
  value: '$497',
  icon: 'video',
  description: 'Construye tu landing en Shopify + tu VSL completo con IA.'
}, {
  week: 'Semana 3',
  title: 'Ads + Orgánico',
  value: '$497',
  icon: 'rocket',
  description: 'Aprende a generar tráfico real desde el día uno.'
}, {
  week: 'Semana 4',
  title: 'Optimización + Escalamiento',
  value: '$497',
  icon: 'chart',
  description: 'Toma decisiones con precisión, no con suerte.'
}];
export function Curriculum() {
  return <section className="py-20 bg-gradient-to-b from-white to-gray-50" data-id="element-30">
      <div className="max-w-6xl mx-auto px-6" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-32">
          <div className="inline-flex items-center gap-2 bg-black text-yellow-400 px-4 py-2 rounded-full text-sm font-bold uppercase tracking-wider mb-4" data-id="element-33">
            <Icon name="target" size={18} data-id="element-34" />
            Curriculum Completo
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold text-black mb-4" data-id="element-35">
            Mira lo que aprenderás dentro
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-36">
          {weeks.map((week, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white border-2 border-gray-200 rounded-xl p-8 hover:border-yellow-400 transition-colors duration-300" data-id="element-37">
              <div className="flex items-start justify-between mb-4" data-id="element-38">
                <div className="flex items-center gap-4" data-id="element-39">
                  <div className="w-12 h-12 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-lg flex items-center justify-center" data-id="element-40">
                    <Icon name={week.icon as any} size={24} className="text-black" data-id="element-41" />
                  </div>
                  <div data-id="element-42">
                    <div className="text-sm font-bold text-yellow-600 uppercase tracking-wider" data-id="element-43">
                      {week.week}
                    </div>
                    <h3 className="text-xl font-bold text-black" data-id="element-44">
                      {week.title}
                    </h3>
                  </div>
                </div>
                <div className="text-right" data-id="element-45">
                  <div className="text-xs text-gray-500 uppercase" data-id="element-46">Valor</div>
                  <div className="text-lg font-bold text-black" data-id="element-47">
                    {week.value}
                  </div>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed" data-id="element-48">
                {week.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}